var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApprovalIco(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "in06lv4tqa"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 7232",
    style: {
      fill: "#fff"
    },
    d: "M0 0h40v46H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 13753"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 13752",
    transform: "translate(10.1 6.353)",
    style: {
      clipPath: "url(#in06lv4tqa)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 18248",
    d: "M36.63 46H3.37A3.319 3.319 0 0 1 0 42.742V3.258A3.319 3.319 0 0 1 3.37 0h33.26A3.319 3.319 0 0 1 40 3.258v39.484A3.319 3.319 0 0 1 36.63 46M3.37 3.04a.227.227 0 0 0-.225.217v39.485a.227.227 0 0 0 .225.217h33.26a.227.227 0 0 0 .225-.217V3.258a.227.227 0 0 0-.225-.217z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 18249",
    d: "M33.086 55.192a1.6 1.6 0 0 1-1.056-.392l-7.319-6.407a1.485 1.485 0 0 1-.11-2.147 1.611 1.611 0 0 1 2.222-.106l6.035 5.283L42.114 39.4a1.608 1.608 0 0 1 2.2-.311 1.487 1.487 0 0 1 .323 2.127L34.348 54.58a1.588 1.588 0 0 1-1.108.605 1.513 1.513 0 0 1-.153.007",
    transform: "translate(-13.324 -21.943)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 18250",
    d: "M43.321 8.8a1.547 1.547 0 0 1-1.573-1.52V2.52a1.573 1.573 0 0 1 3.145 0v4.761A1.547 1.547 0 0 1 43.321 8.8",
    transform: "translate(-22.991 -.566)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 18251",
    d: "M21.684 8.8a1.547 1.547 0 0 1-1.573-1.52V2.52a1.573 1.573 0 0 1 3.145 0v4.761A1.547 1.547 0 0 1 21.684 8.8",
    transform: "translate(-11.075 -.566)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 18252",
    d: "M64.958 8.8a1.547 1.547 0 0 1-1.573-1.52V2.52a1.573 1.573 0 0 1 3.145 0v4.761A1.547 1.547 0 0 1 64.958 8.8",
    transform: "translate(-34.907 -.566)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 18253",
    d: "M23.059 16.745a2.451 2.451 0 1 1-2.45-2.368 2.409 2.409 0 0 1 2.45 2.368",
    transform: "translate(-10.001 -8.132)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 18254",
    d: "M44.7 16.745a2.45 2.45 0 1 1-2.449-2.368 2.409 2.409 0 0 1 2.449 2.368",
    transform: "translate(-21.917 -8.132)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 18255",
    d: "M66.332 16.745a2.45 2.45 0 1 1-2.449-2.368 2.409 2.409 0 0 1 2.449 2.368",
    transform: "translate(-33.832 -8.132)",
    style: {
      fill: "#fff"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovalIco);
export default __webpack_public_path__ + "static/media/approval_ico.2792cd5059c33feb94b5060f448b3954.svg";
export { ForwardRef as ReactComponent };